var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.2811L1.08656 7.58776L0.560293 8.2811L1.08656 8.97443L2 8.2811ZM18.5798 9.42787C19.2132 9.42787 19.7266 8.91444 19.7266 8.2811C19.7266 7.64775 19.2132 7.13432 18.5798 7.13432V9.42787ZM6.61317 0.306665L1.08656 7.58776L2.91344 8.97443L8.44006 1.69333L6.61317 0.306665ZM1.08656 8.97443L6.61317 16.2555L8.44006 14.8689L2.91344 7.58776L1.08656 8.97443ZM2 9.42787H18.5798V7.13432H2V9.42787Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/Left_Arrow.204230f0accaf163cdbb875f647d86ef.svg";
export { ForwardRef as ReactComponent };